import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { DynFormsService } from '../../dyn-forms/logic/dyn-forms.service';
import { DraftSyncEventsService } from '../../dyn-forms/draft-sync-events.service';
import { CloudSyncState } from 'src/app/_model/dyn-form-data';
import { DraftPushNotifier, DraftPushParams } from './draft-push-notifier.service';

/**
 * APP4-948: the backend actively took the draft baton away from this device because another
 * device of the same user claimed the draft. The local draft is marked as
 * OWNED_OTHER_DEVICE and an open form is notified so it can switch to read-only.
 *
 * The document stays an editable draft - that is the difference to draft_finalized,
 * where the draft lifecycle has ended.
 */
@Injectable({
  providedIn: 'root',
})
export class DraftRevokedActionHandler implements ActionHandler {
  public readonly name: ActionHandlerType = 'draft_revoked';

  constructor(
    private logger: LoggingService,
    private dynFormsService: DynFormsService,
    private draftSyncEvents: DraftSyncEventsService,
    private draftPushNotifier: DraftPushNotifier
  ) {}

  public async executeAction(params?: DraftPushParams): Promise<any> {
    const acukey = this.draftPushNotifier.getAcukey(params);
    const acId = this.draftPushNotifier.getAcId(params);
    const chainRootAcId = this.draftPushNotifier.getChainRootAcId(params);
    this.logger.log(
      this.constructor.name,
      'Draft baton revoked by backend for chainRootAcId',
      chainRootAcId,
      'acukey',
      acukey,
      'acId',
      acId
    );
    if (chainRootAcId == undefined && acukey == undefined && acId == undefined) {
      this.logger.warn(
        this.constructor.name,
        'draft_revoked push without chainrootacid, acukey and objid, ignoring'
      );
      return;
    }

    // Matches on the chain identity first (KRK-45): the claiming device created a new AC
    // version, so the pushed acId can already be newer than the one stored here. acukey
    // and acId stay as fallbacks for rows saved before the chain root was persisted.
    await this.dynFormsService.updateCloudSyncStateByDraft(
      acukey,
      acId,
      CloudSyncState.OWNED_OTHER_DEVICE,
      chainRootAcId
    );
    this.draftSyncEvents.draftRevoked$.next({ acukey, acId });
  }
}
